import axios from "axios";

const namespaced = true;

const state = {
    interpolationSettings: []
};

const getters = {
    settings: state => state.interpolationSettings
};

const actions = {
    GET_INTERPOLATION_SETTINGS({ commit }) {
        axios
            .get("/interpolationsetting", {
                params: {
                    system: "markkartering.se"
                }
            })
            .then(response => {
                commit("setInterpolationSettings", response.data);
            });
    },

    UPDATE_SETTING({ commit }, setting) {
        if (setting.active) {
            commit("clearActive", setting.type);
        }

        commit("updateSetting", setting);
    },

    ADD_SETTING({ commit }, setting) {
        if (setting.active) {
            commit("clearActive", setting.type);
        }

        commit("addSetting", setting);
    },

    DELETE_SETTING({ commit }, id) {
        axios.delete("/interpolationsetting/" + id).then(response => {
            commit("deleteSetting", id);
        });
    }
};

const mutations = {
    setInterpolationSettings(state, colors) {
        state.interpolationSettings = colors;
    },

    clearActive(state, type) {
        state.interpolationSettings.forEach(setting => {
            if (setting.type == type && setting.active) {
                setting.active = false;
            }
        });
    },

    updateSetting(state, setting) {
        let found = state.interpolationSettings.find(s => s.id === setting.id);

        if (found) {
            found.title = setting.title;
            found.description = setting.description;
            found.type = setting.type;
            found.interpolation_type = setting.interpolation_type;
            found.smooth_colors = setting.smooth_colors;
            found.system = setting.system;
            found.search_radius = setting.search_radius;
            found.interpolation_factor = setting.interpolation_factor;
            found.interpolate_over_borders = setting.interpolate_over_borders;
            found.active = setting.active;
            found.interpolation_colors = setting.interpolation_colors;
        }
    },

    addSetting(state, setting) {
        state.interpolationSettings.push(setting);
    },

    deleteSetting(state, id) {
        state.interpolationSettings = state.interpolationSettings.filter(
            setting => {
                return setting.id != id;
            }
        );

        bus.$emit("show-notification", "Inställningen togs bort!");
    }
};

export default {
    namespaced,
    state,
    getters,
    actions,
    mutations
};
